<div class="p-2">
	@if (loading) {
	<mat-spinner diameter="32"></mat-spinner>
	} @else if (settings) {
	<div class="settings-form">
		<mat-slide-toggle [checked]="settings.enabled" [disabled]="saving" (change)="onEnabledToggle($event.checked)">
			Автоматско групирање на нови вести
		</mat-slide-toggle>
		@if (settings.activatedAt) {
		<p class="text-muted small mt-1">Вклучено од: {{ formatDate(settings.activatedAt) }}</p>
		}

		<mat-form-field class="mt-3 d-block">
			<mat-label>Интервал (минути)</mat-label>
			<input matInput type="number" min="1" [(ngModel)]="settings.intervalMinutes" />
		</mat-form-field>

		<mat-form-field class="mt-3 d-block">
			<mat-label>Прозорец на живи групи (часови)</mat-label>
			<input matInput type="number" min="1" [(ngModel)]="settings.windowHours" />
		</mat-form-field>

		<mat-form-field class="mt-3 d-block">
			<mat-label>Праг на сличност (0–1)</mat-label>
			<input matInput type="number" min="0" max="1" step="0.01" [(ngModel)]="settings.similarityThreshold" />
		</mat-form-field>

		<mat-form-field class="mt-3 d-block">
			<mat-label>Максимум вести по пакет</mat-label>
			<input matInput type="number" min="1" [(ngModel)]="settings.maxBatchSize" />
		</mat-form-field>

		<div class="mt-3">
			<button mat-flat-button color="primary" [disabled]="saving" (click)="save()">Зачувај</button>
		</div>
	</div>

	<div class="settings-form mt-4">
		<h3>Последни одлуки</h3>
		<p class="text-muted small">Последните {{ dataSource.data.length }} одлуки на системот - за штелување на прагот.</p>

		@if (loadingDecisions) {
		<mat-spinner diameter="24"></mat-spinner>
		} @else {
		<div class="table-responsive">
			<table mat-table [dataSource]="dataSource">
				<ng-container matColumnDef="clipTitle">
					<th mat-header-cell *matHeaderCellDef>Наслов на новата вест</th>
					<td mat-cell *matCellDef="let row">{{ row.clipTitle || '—' }}</td>
				</ng-container>

				<ng-container matColumnDef="decision">
					<th mat-header-cell *matHeaderCellDef>Одлука</th>
					<td mat-cell *matCellDef="let row">{{ decisionLabel(row.decision) }}</td>
				</ng-container>

				<ng-container matColumnDef="bestSimilarity">
					<th mat-header-cell *matHeaderCellDef>Најдобра сличност</th>
					<td mat-cell *matCellDef="let row">{{ formatSimilarity(row.bestSimilarity) }}</td>
				</ng-container>

				<ng-container matColumnDef="bestCandidateMainClipTitle">
					<th mat-header-cell *matHeaderCellDef>Носечка вест на најблиската група</th>
					<td mat-cell *matCellDef="let row">{{ row.bestCandidateMainClipTitle || '—' }}</td>
				</ng-container>

				<ng-container matColumnDef="processedAt">
					<th mat-header-cell *matHeaderCellDef>Време</th>
					<td mat-cell *matCellDef="let row">{{ formatDate(row.processedAt) }}</td>
				</ng-container>

				<tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
				<tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
			</table>
			@if (dataSource.data.length === 0) {
			<p class="text-muted mt-2">Нема одлуки сè уште.</p>
			}
		</div>
		}
	</div>
	}
</div>
